<ng-container *ngIf="(resourceList$ | async) as resourceList">
  <div *ngIf="resourceList.length > 0; else noResources" class="row ps-3 w-100" style="margin-top:30px">
    <div class="col-12 col-md-6 col-lg-4 mb-3" *ngFor="let resource of resourceList; index as i">
      <div class="card-wrapper">
        <div class="card shadow-sm resource-card d-flex flex-column align-items-center"
          style="max-width: 100%; height: 150px;">
          <ng-container *ngIf="resource.link; else noLink">
            <a class="card-header p-1 text-center text-decoration-none w-100"
              [ngStyle]="{'background-color': getBackgroundColor(resource?.entityTypeName)}"
              (click)="navigateToResource(resource)">
              <b class="card-title fs-6 mb-0 white-color" placement="bottom" ngbTooltip="Vai alla risorsa">
                {{ resource?.entityTypeName.replaceAll("_", " ") }}
              </b>
            </a>
          </ng-container>
          <ng-template #noLink>
            <div class="card-header p-1 text-center w-100"
              [ngStyle]="{'background-color': getBackgroundColor(resource?.entityTypeName)}">
              <b class="card-title fs-6 mb-0 white-color">
                {{ resource?.entityTypeName.replaceAll("_", " ") }}
              </b>
            </div>
          </ng-template>
          <div class="card-body p-1 flex-column w-100">
            <div class="mb-2">
              <strong>Identificativo:</strong> {{ resource?.data?.codiceEntita || 'N/D' }}
            </div>
            <div>
              <strong>Descrizione:</strong>
              <span [style.cursor]="resource?.data?.descrizioneEntita.length > 100 ? 'default' : ''" [autoClose]="false"
                placement="bottom"
                [ngbTooltip]="resource?.data?.descrizioneEntita.length > 100 ? resource?.data?.descrizioneEntita : ''">
                {{ (resource?.data?.descrizioneEntita || 'N/D') | truncate: [100] }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noResources>
    <div class="text-center" style="margin-top:80px">
      <p class="fw-bold">Nessuna risorsa associata</p>
    </div>
  </ng-template>
</ng-container>